var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "20231228",
                reset: true,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                ),
                "auto-init": _vm.searchItemAutoInit,
                "custom-search-items": _vm.customSearchItems
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              },
              scopedSlots: _vm._u([
                {
                  key: "searchAreaHeader",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "app-main-inner-row  extension-conditions-form",
                          staticStyle: {
                            "padding-bottom": "5px",
                            "margin-top": "-7px"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "filters" },
                            [
                              _c(
                                "el-form",
                                {
                                  attrs: {
                                    inline: true,
                                    "label-width": "60px",
                                    "label-position": "left"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "el-form-item-wrapper dense-radio-group"
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "dense-radio-group",
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value: _vm.filter.viewType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.filter,
                                                    "viewType",
                                                    $$v
                                                  )
                                                },
                                                expression: "filter.viewType"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 1 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.ViewReception"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: 0 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.ViewSending"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "button1", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toPassChargeSync()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "button2", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.toNotPassChargeSync()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("FinanceManage.fail")) + " ")]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "20231228",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c(
                "div",
                { staticClass: "total-wrapper", class: ["fixedBottom"] },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCount,
                          expression: "showCount"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.$t("SeaExport.Select") +
                              " " +
                              _vm.selectionCount +
                              ":"
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-content": "center",
                        "padding-left": "5px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "13px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ReceivableToCNY"))
                          )
                        ]
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.receivable))])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-content": "center",
                        "padding-left": "5px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "13px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DuesToCNY")))]
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.dues))])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-content": "center",
                        "padding-left": "5px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "13px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EquivalentCNY")))]
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.amountTo))])
                    ]
                  ),
                  _c("charge-count-group", {
                    attrs: {
                      "data-provider": _vm.selectedRows,
                      "data-field": "amount",
                      "display-and-count-field-list":
                        _vm.displayAndCountFieldList,
                      "always-show": true
                    }
                  })
                ],
                1
              ),
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "990003",
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQueryByPage
                }
              })
            ],
            1
          ),
          _vm.rejectWindow.visible
            ? _c("reject-dialog", {
                attrs: {
                  visible: _vm.rejectWindow.visible,
                  "job-no": _vm.rejectWindow.jobNo,
                  "reject-call-back": _vm.rejectWindow.rejectCallBack,
                  "append-to-body": true
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.rejectWindow, "visible", $event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }